export default __webpack_public_path__ + "static/media/facebook.2c9249c8.svg";